<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M12.552 31.448c-1.041-1.042-2.73-1.042-3.771 0-1.041 1.041-1.041 2.73 0 3.771l13.333 13.333c1.042 1.042 2.73 1.042 3.772 0L55.219 19.22c1.041-1.041 1.041-2.73 0-3.771-1.041-1.042-2.73-1.042-3.771 0L24 42.895 12.552 31.448z" transform="translate(-66 -911) translate(66 911)"/>
            </g>
        </g>
    </g>
</svg>
